// extracted by mini-css-extract-plugin
export var checkbox = "_8i-0";
export var circle = "_8i-3";
export var horizontalContainer = "_8i-7";
export var sm = "_8i-5";
export var switch0 = "_8i-2";
export var switchDisabled = "_8i-8";
export var switchEnabled = "_8i-1";
export var textSwitchContainer = "_8i-9";
export var textSwitchOption = "_8i-a";
export var textSwitchOptionSelected = "_8i-b";
export var verticalContainer = "_8i-6";
export var xs = "_8i-4";